<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.sites'), name: 'company_sites' }, { text: site.name }]" />
      </template>
      <template v-slot:meta>
        <Link :to="`/company/sites`" class="button button-grey button-small button-round">
          {{ $t('sites.allSites') }}
        </Link>
      </template>
    </SectionHeader>

    <div class="body-content">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <div v-else>
          <SiteForm @submit="updateSite" :initialSite="site" :zones="zones" />
          <AreaIndex :site="site" @reloadSite="getSite" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AreaIndex from '@/views/companies/sites/AreaIndex.vue'
import SiteForm from '@/views/companies/sites/SiteForm'

import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sitesApi from '@/api/sites'
import zonesApi from '@/api/zones'

export default {
  data: () => ({
    site: {},
    loading: true,
    zones: [],
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
    AreaIndex,
    SiteForm,
  },
  methods: {
    async updateSite(site) {
      this.site = await sitesApi.update(site.uuid, site)
    },
    async getSite() {
      this.site = await sitesApi.get(this.$route.params.site_uuid)
    },
    async getData() {
      this.loading = true
      await this.getSite()
      this.zones = await zonesApi.getAllInSite(this.$route.params.site_uuid)
      this.loading = false
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
